import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

/**
 * Componente para manejar meta tags SEO y Open Graph en toda la aplicación
 * @param {Object} props - Propiedades del componente
 * @param {string} props.title - Título de la página
 * @param {string} props.description - Descripción de la página
 * @param {string} props.image - URL de la imagen para compartir
 * @param {string} props.url - URL de la página actual
 * @param {string} props.type - Tipo de contenido (article, website, etc.)
 * @param {boolean} props.override - Si es true, reemplaza los meta tags existentes
 */
const SEOHelmet = ({
  title = "Click To Pray",
  description = "Click To Pray connects you with thousands of people who find purpose in praying every day for the challenges of humanity and for the mission of the Church",
  image = `https://clicktopray.org/ctp-share.jpg`   ,
  url = typeof window !== "undefined" ? window.location.href : "",
  type = "website",
  override = false,
}) => {
  // Usar la imagen por defecto si no se proporciona una
  const defaultImage = `https://clicktopray.org/ctp-share.jpg`;
  const finalImage = image || defaultImage;
  return (
    <Helmet
      // Si override es true, reemplaza todos los meta tags existentes
      // Si es false, solo añade los que no existan
      encodeSpecialCharacters={true}
      defaultTitle="Click To Pray"
      titleTemplate="%s | Click To Pray"
      prioritizeSeoTags={override}
    >
      {/* Meta tags básicos */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={finalImage} />
    </Helmet>
  );
};

SEOHelmet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  type: PropTypes.string,
};

export default SEOHelmet;
